<div class="d-flex">
  <h1 class="page-title me-5 mb-2">Correction Payroll</h1>
  <button
    cpGTagEvent
    [params]="{ event_label: 'payroll_review_return_to_grid' }"
    routerLink="/client/{{ clientCode }}/payroll-corrections"
    class="btn btn-secondary d-print-none d-flex align-items-center me-3">
    <i class="fas fa-lg fa-angle-left pe-1"></i>
    <span>&nbsp;Back</span>
  </button>
  <div *ngIf="hasRecentHistoryVoids" class="error">
    History voids included in this payroll. Confirm banking app corrections are complete before
    submitting payroll
  </div>
  <button
    preventMultiClick
    (throttledClick)="submitApproval(submitApprovalModal)"
    [throttleTime]="2000"
    cpGTagEvent
    [params]="{ event_label: 'payroll_review_submit' }"
    class="btn btn-primary d-print-none ms-auto">
    Submit Payroll
  </button>
</div>

<div class="d-flex mt-4 payroll-info" *ngIf="payroll">
  <div>
    <small>
      <span class="me-3" data-testid="header-periodBegin">
        First Day of Pay Cycle:&nbsp;<strong>{{ payrollMgmt.periodBeginDisplay(payroll) }}</strong>
      </span>
      <span class="me-3" data-testid="header-periodEnd">
        Last Day of Pay Cycle:&nbsp;
        <strong>
          {{ payrollMgmt.periodEndDisplay(payroll, true) }}
        </strong>
      </span>
      <span class="me-3" data-testid="header-payDate">
        Pay Date:&nbsp;<strong>{{
          payroll.PayDate.toString() | slice: 0 : 10 | date: 'MM/dd/yyyy'
        }}</strong>
      </span>
    </small>
  </div>
  <div class="ms-auto">
    <a (click)="print()" class="cp-green d-print-none">
      <small>Print <i class="fas fa-print"></i></small>
    </a>
  </div>
</div>

<hr />

<!-- Cash Required for Pay Date -->
<div ngbAccordion class="payrollAccordion">
  <div
    ngbAccordionItem
    ngbAccordionItem="cashRequired"
    #cashRequired="ngbAccordionItem"
    [collapsed]="false">
    <h2 ngbAccordionHeader [title]="cashRequired.collapsed ? 'Click to View' : 'Click to hide'">
      <button ngbAccordionButton>
        <h4>
          Payroll Totals for Pay Date
          {{ payroll == null ? '' : (payroll.PayDate | date: 'MM/dd/yy') }}
        </h4>
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <preview-cash-required
            *ngIf="payrollSummary && orderedLists"
            [payrollSummary]="payrollSummary"
            [orderedLists]="orderedLists" />
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div ngbAccordion class="payrollAccordion">
  <div
    ngbAccordionItem
    ngbAccordionItem="paylineDetails"
    #paylineDetails="ngbAccordionItem"
    [collapsed]="false">
    <h2 ngbAccordionHeader [title]="paylineDetails.collapsed ? 'Click to View' : 'Click to Hide'">
      <button ngbAccordionButton>
        <h4>Payline Details</h4>
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <div *ngIf="payroll?.EmployeePays && configSetupData">
            <div *ngFor="let pay of payroll.EmployeePays">
              <payline-detail-table
                [clientCode]="clientCode"
                [configSetupData]="configSetupData"
                [pay]="pay"
                [payroll]="payroll"
                [divisions]="divisions">
              </payline-detail-table>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- History Void Pays/Payments -->
<div *ngIf="payroll && configSetupData">
  <lib-history-void-report
    (showHistoryVoidMessage)="showHistoryVoidMessage($event)"
    [clientCode]="clientCode"
    [deductionConfigs]="configSetupData.Deductions"
    [payroll]="payroll"></lib-history-void-report>
</div>

<ng-template #submitApprovalModal let-modal>
  <confetti-effect *ngIf="isPayrollApproved"></confetti-effect>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      <ng-container *ngIf="isPayrollApproved; then approvedHeader; else notApprovedHeader">
      </ng-container>
      <ng-template #approvedHeader>
        <i class="fas fa-lg fa-check-circle success"></i
        ><span class="headerTitle">Payroll Confirmed</span><br />
        <small
          >This correction payroll has been
          <span class="success">successfully</span> submitted!</small
        >
      </ng-template>
      <ng-template #notApprovedHeader>
        <i class="fas fa-lg fa-times-circle error"></i
        ><span class="headerTitle">Payroll Errors</span><br />
        <small
          >This correction payroll has <span class="error">NOT</span> yet been submitted!</small
        >
      </ng-template>
    </h4>
    <button
      cpGTagEvent
      [params]="{ event_label: 'payroll_preview_submit_modal_dismiss' }"
      type="button"
      class="close"
      aria-label="Close"
      (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ng-container *ngIf="isPayrollApproved; then approvedBody; else notApprovedBody">
    </ng-container>
    <ng-template #approvedBody>
      <h6 class="mb-1">Payroll Info</h6>
      <div class="d-flex justify-content-between">
        <div class="smallfont text-start">
          <div>Client Number</div>
          <div>Client Name</div>
          <div>Period End Date</div>
          <div>Pay Date</div>
          <div>Sequence Number</div>
        </div>
        <div class="text-end smallfont justify-content-end flex-fill">
          <div>{{ clientCode }}</div>
          <div>{{ clientName }}</div>
          <div>{{ payrollMgmt.periodEndDisplay(payroll, true) }}</div>
          <div>{{ payroll.PayDate | date: 'MM/dd/yyyy' }}</div>
          <div>{{ payroll.SequenceNumber }}</div>
        </div>
      </div>
      <div>
        <hr class="mb-1 mt-1" />
      </div>
      <!-- Debit -->
      <div>
        <h6 class="mb-1">Debit</h6>
        <div class="d-flex justify-content-between">
          <div class="smallfont text-start">
            <div>Payroll Debit</div>
            <div>Tax Filing Debit</div>
            <div>3rd Party Disbursement ACH</div>
            <div>Billing Debit</div>
            <div class="fw-bold">Total Debit Amount</div>
          </div>

          <div class="text-end smallfont justify-content-end flex-fill">
            <div>
              {{ payrollApprovalTotals.PayrollDebit || 0 | number: '1.2-2' }}
            </div>
            <div>
              {{ payrollApprovalTotals.TaxFilingDebit || 0 | number: '1.2-2' }}
            </div>
            <div>
              {{ payrollApprovalTotals.ThirdPartyDisbursementAch || 0 | number: '1.2-2' }}
            </div>
            <div>
              {{ payrollApprovalTotals.BillingDebit || 0 | number: '1.2-2' }}
            </div>
            <div class="fw-bold">{{ approveTotals['DebitTotal'] || 0 | number: '1.2-2' }}</div>
          </div>
        </div>
        <div>
          <hr class="mb-1 mt-1" />
        </div>
      </div>
      <!-- Errors/Warnings/Informations -->
      <!--
        Bug 8455. weirdly we can get error messages back here,
        but the submit approval request was still successful
      -->
      <div *ngIf="responseMessages && responseMessages.length > 0">
        <div *ngFor="let msg of responseMessages">
          <div class="d-flex mt-1 mb-1">
            <h6
              [className]="
                msg.WarningLevel == 'Warning'
                  ? 'warning'
                  : msg.WarningLevel == 'Critical'
                    ? 'error'
                    : 'info'
              ">
              {{ msg.WarningLevel }}&nbsp;
            </h6>

            <div class="smallfont" style="width: 300px">
              {{ msg.Message }}
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="d-flex justify-content-center">
        <button
          cpGTagEvent
          [params]="{ event_label: 'payroll_preview_return_home' }"
          class="btn btn-primary"
          (click)="closeModal()">
          Return Home
        </button>
      </div>
    </ng-template>
    <ng-template #notApprovedBody>
      <!-- Errors/Warnings/Informations -->
      <div *ngIf="responseMessages && responseMessages.length > 0">
        <div *ngFor="let msg of responseMessages">
          <div class="d-flex mt-1 mb-1">
            <h6
              [className]="
                msg.WarningLevel == 'Warning'
                  ? 'warning'
                  : msg.WarningLevel == 'Critical'
                    ? 'error'
                    : 'info'
              ">
              {{ msg.WarningLevel }}&nbsp;
            </h6>

            <div class="smallfont" style="width: 300px">
              {{ msg.Message }}
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="d-flex justify-content-center">
        <button
          cpGTagEvent
          [params]="{ event_label: 'payroll_preview_return_to_grid' }"
          class="btn btn-primary"
          (click)="closeModal()">
          Return to Payroll Grid
        </button>
      </div>
    </ng-template>
  </div>
</ng-template>
